import { pbiMockDataEnabledAtom } from "../../state/pbi.atoms";
import {
  SisterSearcherInImosFilter,
  SisterSearcherSimilarityCriteria,
  SisterSearcherView,
} from "../models/sister-searcher.models";
import { atom } from "jotai";

// Mirrors the shared source choice while keeping Sister Searcher filters and selections feature-local.
export const sisterSearcherMockEnabledAtom = pbiMockDataEnabledAtom;

export const sisterSearcherSimilarityAtom = atom<Omit<SisterSearcherSimilarityCriteria, "inImos">>({
  sameCountryOfBuild: true,
  sameDesign: true,
  sameDwt: true,
  sameEngine: true,
  sameYard: true,
  yearsBefore: 10,
  yearsAfter: 10,
});

export const sisterSearcherInImosAtom = atom<SisterSearcherInImosFilter>("all");
export const sisterSearcherSelectedImoAtom = atom("");
export const sisterSearcherViewAtom = atom<SisterSearcherView>("landing");
